<template>
    <div id="career" class="page career">
        <div class="career__head">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12 col-xl-10 offset-xl-1">
                        <h1>{{ lang('carrier_allasajanlatok') }}</h1>
                        <p>{{ lang('carrier_head_text_1')}}</p>
                        <p>
                            {{ lang('carrier_head_text_2_1')}} 
                            <span class="show_email" @click.stop="showThisEmail(emailAddress)">{{lang('carrier_head_text_2_2')}}</span> 
                            {{lang('carrier_head_text_2_3')}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="career__content" v-if="getDataSuccess===true">
            <div class="container-xl" >
                <div class="row" v-if="currentPositions.length > 0">
                    <div class="col-12 col-md-6" v-for="career in currentPositions" :key="career.id">
                        <CareerItem
                            :id="career.id"
                            :name="career.name"
                            :slug="career.slug"                            
                            :src="itemSrc(career, 'w440h220')" 
                        />
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12">
                        <div class="no-results">
                            {{ lang('nincs_aktualis_allasajanlat') }}
                        </div>                        
                    </div>
                </div>
            </div>            
        </div>
        <div v-else class="container-xl">
            <div class="row">
                <div class="col-12">
                    <Loading />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import CareerItem from '@/components/pagesComponents/career/CareerItem.vue'
import Loading from '@/components/layoutComponents/Loading.vue'
import $ from "jquery"

export default {
    data(){
        return{
            currentPositions:[],
            getDataSuccess: false,
            emailAddress: 'karrier'
        }        
    },
    components:{
        CareerItem,
        Loading
    },
    methods:{
        getAllCarriers (){
            
            var where = '';
            if (this.$store.state.needPD)
            {
                where = '&where[2][0]=where&where[2][1]=published_date <=&where[2][2]='+ new Date().toISOString().slice(0, 19).replace('T', ' ');
            }

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information?relations=1&where[0][0]=where&where[0][1]=type&where[0][2]=career&where[1][0]=where&where[1][1]=status&where[1][2]=1&order_by[0][0]=sort_order&order_by[0][1]=asc&order_by[1][0]=name&order_by[1][1]=asc'+where,{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {                
                if (response.data.status == true ){
                    this.currentPositions = response.data.information
                    this.getDataSuccess = true
                } else {
                    this.currentPositions = []
                    this.getDataSuccess = true
                }                                                          
            })
            .catch((err) => {
                console.log(err)
            }); 
        },
        showThisEmail(key){
            let clickedItem = event.target
            let emailDomain = 'univer.hu'
            let emailAddress = '<a href="mailto:' + key + "@" + emailDomain +'">' + key + '@' + emailDomain + '</a>'

            $(clickedItem).html(emailAddress)
            
        },
    },
    created(){
        this.getAllCarriers()
    },
    mounted(){
        this.setMetaTags({
            title: this.lang('{title_karrier}'), 
            desc: this.lang('meta_description_karrier'), 
            keywords:this.lang('meta_keywords_karrier'), 
            ogType: 'article', 
            ogTitle: this.lang('{title_karrier}'),                         
            ogImage: null, 
            ogImageWidth: null, 
            ogImageHeight: null, 
            ogDesc:this.lang('meta_description_karrier')
        })
    }
}
</script>